<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset="reset" ref="pageRef">
        <template slot="tableColumn">
          <el-table-column
              prop="configName"
              width="350px"
              :label="$t('text.configName')"
              align="center"/>

          <el-table-column
              prop="remark"
              width="300px"
              :label="$t('text.configRemark')"
              align="center"
              style="padding-left: 10px"
          />

          <el-table-column prop="config"
                           width="300px"
                           :label="$t('text.config')"
                           align="center">
            <template slot-scope="{ row }">
              <el-popover v-if="row.config && row.config.length > 35"
                          placement="top-start"
                          width="400"
                          trigger="hover">
                <div v-html="cleanedHtml(row.config)" :style="{ fontSize: '12px', lineHeight: '1.4' }"></div>
                <div slot="reference" class="config">
                  {{ row.config }}
                </div>
              </el-popover>
              <div v-else> {{ row.config }}</div>
            </template>
          </el-table-column>


          <el-table-column
              prop="enabled"
              :label="$t('text.enabled')"
              align="center"
              width="120px"
              style="padding-left: 10px">
            <template slot-scope="{ row }">
              <el-tag
                  size="small"
                  :type="row.enabled  ? 'success': 'danger'"
              >
                {{ $formatter.formatRechargeEnabledType(null, null, row.enabled, null) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
              prop="operator"
              width="100px"
              :label="$t('text.operator')"
              align="center"
              style="padding-left: 10px"
          />

          <el-table-column
              prop="updateTime"
              width="150px"
              :label="$t('text.updateTime')"
              align="center"
              style="padding-left: 10px"
          />

          <el-table-column :label="$t('text.actions')"
                           width="300px"
                           header-align="center"
                           align="center"
                           style="padding-left: 10px">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain @click="isShowConfigEditDia(scope.row)">
                {{ $t('text.edit') }}
              </el-button>
              <el-switch
                  v-model="scope.row.enabled"
                  class="switch"
                  :inline-prompt="true"
                  :active-text="$t('creditFlag.01')"
                  :inactive-text="$t('creditFlag.00')"
                  style="left: 15px;"
                  :loading="loading"
                  @change="enabledStatusChange(scope.row)"
              />
            </template>

          </el-table-column>
        </template>
      </page>

      <el-dialog
          :visible.sync="isShowConfigEditDiaLog"
          :title="$t('text.configEdit')"
          width="600px"
          @close="closeDialog"
      >
        <el-form ref="form2" :model="form2" label-width="170px">
          <el-form-item :label="$t('text.configName')">
            <el-input v-model="form2.configName" autocomplete="off" disabled/>
          </el-form-item>

          <el-form-item :label="$t('text.configRemark')">
            <el-input v-model="form2.remark" autocomplete="off"  type="textarea" :autosize="{ minRows: 3 }"/>
          </el-form-item>

          <div v-for="(configItem, param) in parsedConfig" :key="param" class="config-section">
            <el-form-item :label="$t('text.configParams', { param })">
              <el-input
                  type="text"
                  :placeholder="$t('message.input')"
                  v-model="parsedConfig[param]"
                  @input="handleConfigInput(param, $event)"
              />
            </el-form-item>
          </div>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog" :loading="loading">{{ $t('text.cancel') }}</el-button>
          <el-button type="primary" @click="submitConfig" :loading="loading"
          >{{ $t('text.confirm') }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>

import Page from "@/components/Page.vue";
import loading from "element-ui/packages/loading";
import moment from "moment";
import {ROLE_TYPE} from "@/utils/Constant";


export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page,
  },
  data() {
    return {
      url: "config/selectAll",
      form: {
        config: "",
        remark: "",
      },
      form2: {
        configName: "",
        config: "",
        remark: "",
      },
      isShowConfigEditDiaLog: false,
      parsedConfig: [],
      loading: false,
    };
  },
  methods: {
    reset() {
      this.traceId = "";
      this.message = "";
    },
    isShowConfigEditDia(row) {
      this.isShowConfigEditDiaLog = true;
      try {
        this.form2 = row;
        this.parsedConfig = JSON.parse(row.config);
      } catch (err) {
        console.log(err)
        this.$message.error("配置格式错误，请确保内容为 JSON 数组！");
        this.isShowConfigEditDiaLog = false;
      }
    },
    closeDialog() {
      this.isShowConfigEditDiaLog = false;
      this.parsedConfig = [];
    },
    handleConfigInput(index, value) {
      if (typeof value === 'string') {
        this.$set(this.parsedConfig, index, value);
      }
    },
    submitConfig() {
      try {
        this.form2.config = JSON.stringify(this.parsedConfig);
        const config = {
          configName: this.form2.configName,
          config: this.form2.config,
          remark: this.form2.remark,
          enabled: this.form2.enabled,
        }
        this.enabledStatusChange(config);
      } catch (err) {
        console.error('Error resetting config:', err);
      }
    },
    enabledStatusChange(row) {
      if (!this.isJsonValid(row.config)) {
        this.$message.error(`${this.$t('message.someFieldsAreEmpty')}`);
        return;
      }

      const configs = [
        {
          configName: row.configName,
          config: row.config,
          remark: row.remark,
          enabled: row.enabled,
        }
      ];
      this.loadingOpen();
      this.$axios
          .put('/config/updates', configs, {
            headers: {'Content-Type': 'application/json'},
            transformRequest: [(data) => JSON.stringify(data)],
          })
          .then((res) => {
            if (res.code === 200) {
              this.$refs.pageRef.refresh();
              this.closeDialog();
              this.$notify({
                title: `${this.$t('text.success')}`,
                message: res.msg,
                type: 'success',
              });
              return true;
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg,
              });
              return false;
            }
          })
          .catch(() => {
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: this.$t('message.sysError'),
            });
          })
          .finally(() => {
            this.loadingClose();
          });
    },
    isJsonValid(config) {
      let json

      if (typeof config === 'string') {
        try {
          json = JSON.parse(config);
        } catch (err) {
          this.$message.error('配置解析失败，请确保为 JSON 格式！');
          return;
        }
      } else {
        json = config;
      }

      if (typeof json !== 'object' || json === null) {
        return false;
      }

      let hasInvalid = false;

      function deepCheck(obj) {
        for (let key in obj) {
          const value = obj[key];
          if (
              value === null ||
              value === undefined ||
              (typeof value === 'string' && value.trim() === '') ||
              (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
          ) {
            hasInvalid = true;
            return;
          }

          if (typeof value === 'object' && value !== null) {
            deepCheck(value);
          }
        }
      }

      deepCheck(json);

      return !hasInvalid;
    },
    loadingOpen() {
      this.loading = true;
      this.$refs.pageRef.loadingOpen();
    },
    loadingClose() {
      this.loading = false;
      this.$refs.pageRef.loadingClose();
    },
    cleanedHtml(str) {
      try {
        const json = JSON.parse(str);
        return JSON.stringify(json, null, 1).replace(/\s/g, '&nbsp;')
            .replace('{', '{<br>')
            .replace('}', '<br>}')
            .replace(/\s*,\s*/g, ',<br>');
      } catch (error) {
        console.error('Invalid JSON:', str);
        return str;
      }
    },

  },
  created() {
    this.reset();
  },
};
</script>

<style scoped>
.config {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-popover pre {
  max-width: 750px;
  max-height: 500px;
  overflow: auto;
  white-space: pre-wrap;
}

</style>

<style lang="scss">
.switch .el-switch__label {
  position: absolute;
  display: none;
  color: #fff !important;
}

.switch .el-switch__label--right {
  z-index: 1;
}

.switch .el-switch__label--left {
  z-index: 1;
}

.switch .el-switch__label.is-active {
  display: block;
}

.switch .el-switch__core,
.el-switch .el-switch__label {
  width: 75px !important;
  margin: 0;
}
</style>
